import React from 'react';
import _ from 'lodash';
import { AxlInput, AxlPanel, AxlTextArea, AxlReselect } from 'axl-reactjs-ui';

// styles
import styles, * as E from '../../styles';

export default class SingleOrderStepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render() {
    const {shipment, shipmentStore, getFormError, getFormValue, handleInputForm, handleSelectWarehouse, isStoreUser} = this.props;

    let warehouseOpts = [];
    let selectedWarehouse = {};
    if (shipmentStore.warehouses && shipmentStore.warehouses.length > 0) {
      warehouseOpts = _.map(shipmentStore.warehouses, (wh, index) => {
        const ownerFacilityId = wh.owner_facility_id ? `[ #${wh.owner_facility_id} ] -- ` : '';
        return {
          label: `${ownerFacilityId}${wh.address.street}${wh.address.street2 ? `, ${wh.address.street2}`: ''}, ${wh.address.city}, ${wh.address.state}`,
          value: index.toString()
        }
      })
    } else if(shipment.pickup_address) {
      const whObj = {
        label: `${shipment.pickup_address.street}${_.defaultTo(shipment.pickup_address.street2 && ', ' + shipment.pickup_address.street2, '')}, ${shipment.pickup_address.city}, ${shipment.pickup_address.state}`,
        value: '0'
      };

      warehouseOpts = [whObj];
      selectedWarehouse = whObj;
    } else {
      warehouseOpts = [];
    }

    if (!isStoreUser) {
      warehouseOpts.push({
        label: `Create new pickup address`,
        value: 'new',
      });
    }

    if (this.props.selectedWarehouse > -1) {
      const selectedIndex = warehouseOpts.findIndex(warehouse => warehouse.value === shipmentStore.selectedWarehouse.toString());
      selectedWarehouse = warehouseOpts[selectedIndex];
    } else if (this.props.selectedWarehouse === 'new') {
      selectedWarehouse = {
        label: `Create new pickup address`,
        value: 'new',
      };
    }

    const isCreateNewPickup = this.props.selectedWarehouse === "new";

    return (
      <E.StepContainer>
        <E.Panel>
          <E.PanelTitle>{`Pickup Information`}</E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label isError={!!getFormError("pickup_address")}>{`Pick-Up Address`}<E.Text_4 isError={!!getFormError("pickup_address")}>{` - required`}</E.Text_4></E.Label>
                  {warehouseOpts && warehouseOpts.length > 0 && (
                    <AxlReselect
                      fluid showError={false}
                      name="pickup_address"
                      error={getFormError("pickup_address")}
                      theme={`main`}
                      placeholder={'Select pickup address'}
                      onChange={handleSelectWarehouse}
                      options={warehouseOpts}
                      value={selectedWarehouse}
                    />
                  )}
                </AxlPanel.Col>
              </AxlPanel.Row>
              {isCreateNewPickup && (<div>
                <AxlPanel.Row style={styles.row}>
                  <AxlPanel.Col style={styles.col}>
                    <E.Label>{`Address line 1`}<E.Text_4>{` - required`}</E.Text_4></E.Label>
                    <AxlInput
                      placeholder={`Street`}
                      onChange={handleInputForm}
                      name="pickup_address.street"
                      error={getFormError("pickup_address.street")}
                      value={getFormValue("pickup_address.street")}
                      fluid
                      style={styles.input}
                    />
                  </AxlPanel.Col>
                </AxlPanel.Row>
                <AxlPanel.Row style={styles.row}>
                  <AxlPanel.Col style={styles.col}>
                    <E.Label>{`Address line 2`}</E.Label>
                    <AxlInput
                      placeholder={`Apt/suite/unit...`}
                      onChange={handleInputForm}
                      name="pickup_address.street2"
                      error={getFormError("pickup_address.street2")}
                      value={getFormValue("pickup_address.street2")}
                      fluid
                      style={styles.input}
                    />
                  </AxlPanel.Col>
                </AxlPanel.Row>
                <E.Row>
                  <E.Col>
                    <E.Label>{`City`}<E.Text_4>{` - required`}</E.Text_4></E.Label>
                    <AxlInput
                      onChange={handleInputForm}
                      name="pickup_address.city"
                      error={getFormError("pickup_address.city")}
                      value={getFormValue("pickup_address.city")}
                      placeholder="City"
                      style={styles.input_2}
                      type={`text`}
                    />
                  </E.Col>
                  <E.Col>
                    <E.Label>{`State`}<E.Text_4>{` - required`}</E.Text_4></E.Label>
                    <AxlInput
                      onChange={handleInputForm}
                      name="pickup_address.state"
                      error={getFormError("pickup_address.state")}
                      value={getFormValue("pickup_address.state")}
                      placeholder="State"
                      style={styles.input_2}
                      type={`text`}
                    />
                  </E.Col>
                  <E.Col>
                    <E.Label>{`Zipcode`}<E.Text_4>{` - required`}</E.Text_4></E.Label>
                    <AxlInput
                      onChange={handleInputForm}
                      name="pickup_address.zipcode"
                      error={getFormError("pickup_address.zipcode")}
                      value={getFormValue("pickup_address.zipcode")}
                      placeholder="Zipcode"
                      style={styles.input_2}
                      type={`text`}
                    />
                  </E.Col>
                </E.Row>
                <E.Row>
                  <E.Col>
                    <E.Label>{`Latitude`}</E.Label>
                    <AxlInput
                      onChange={handleInputForm}
                      name="pickup_address.latitude"
                      error={getFormError("pickup_address.latitude")}
                      value={getFormValue("pickup_address.latitude")}
                      style={styles.input_2} type={`text`}
                      disabled
                    />
                  </E.Col>
                  <E.Col>
                    <E.Label>{`Longitude`}</E.Label>
                    <AxlInput
                      onChange={handleInputForm}
                      name="pickup_address.longitude"
                      error={getFormError("pickup_address.longitude")}
                      value={getFormValue("pickup_address.longitude")}
                      style={styles.input_2}
                      type={`text`}
                      disabled
                    />
                  </E.Col>
                </E.Row>
              </div>)}
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Pick-Up Note`}</E.Label>
                  <AxlTextArea
                    placeholder={`Specify pickup notes here...`}
                    onChange={handleInputForm}
                    name="pickup_note"
                    error={getFormError("pickup_note")}
                    value={getFormValue("pickup_note")}
                    fluid
                    style={styles.textarea}
                  />
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
      </E.StepContainer>
    );
  }
}
